<template>
  <page-edicion>
    <page-header title="Crear país" back-to="/paises" />
    <formulario :pais="pais" @submit="insertar" />
  </page-edicion>
</template>

<script>
import Formulario from "./Formulario.vue";
import * as paisesApi from "@/services/paises.js";

export default {
  components: { Formulario },
  data() {
    return {
      pais: paisesApi.crear(),
    };
  },
  methods: {
    insertar() {
      paisesApi.insertar(this.pais).then(() => {
        this.$messages.success("Se ha creado el país");
        this.$router.push({ path: "/paises" });
      });
    },
  },
};
</script>
